import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { type ShipperDetail } from '../domain/shippers'
import { ShipperRepository } from '../infra/ShipperRepository'

export type GetShipperDetailFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export function getShipperDetailFactory({
  shipperRepository,
}: GetShipperDetailFactoryDependencies) {
  return async function getShipperDetailImpl(
    uuid: string,
    config?: { signal?: AbortSignal }
  ): Promise<ShipperDetail> {
    return shipperRepository.getShipperByUUID(uuid, config)
  }
}

export function getShipperDetail(
  uuid: string,
  config?: { signal?: AbortSignal }
): Promise<ShipperDetail> {
  const httpClient = new HttpClient(API_URL)
  const shipperRepository = new ShipperRepository({ httpClient })
  const getDetail = getShipperDetailFactory({ shipperRepository })
  return getDetail(uuid, config)
}
